document.documentElement.classList.remove('no-js');
document.addEventListener('click', (e) => {
  const thumb = e.target.closest('[data-product-thumb]');
  if (thumb) {
    const target = document.querySelector('[data-product-main-image]');
    if (target && thumb.dataset.full) {
      target.src = thumb.dataset.full;
      target.srcset = '';
    }
  }
});
document.addEventListener('change', (e) => {
  if (e.target.matches('[data-sort-by]')) {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', e.target.value);
    window.location.href = url.toString();
  }
});